import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';
import resumePDF from '../assets/suraj_resume.pdf';

const Footer = () => {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.8 }}
    >
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About</h3>
            <p>Tech Engineer, Tech Consultant & Founder of Solutionspath Technology. Based in Nepal 🇳🇵</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Download</h3>
            <ul>
              <li>
                <a 
                  href={resumePDF} 
                  download="Suraj_Kumar_Sah_Resume.pdf"
                  className="resume-download"
                >
                  📥 My Resume
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Me</h3>
            <div className="social-links">
              <a href="https://github.com/Suraj0915" target="_blank" rel="noopener noreferrer" className="social-link github">
                <span>GitHub</span> 🔗
              </a>
              <a href="https://www.linkedin.com/in/surajkumarsah0915/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                <span>LinkedIn</span> 💼
              </a>
              <a href="https://twitter.com/SurajShah47151" target="_blank" rel="noopener noreferrer" className="social-link twitter">
                <span>Twitter</span> 🐦
              </a>
              <a href="https://wa.me/9779844511713" target="_blank" rel="noopener noreferrer" className="social-link whatsapp">
                <span>WhatsApp</span> 💬
              </a>
              <a href="mailto:surajshah0915@gmail.com" className="social-link email">
                <span>Email</span> 📧
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Suraj Kumar Sah. All rights reserved. | Designed with ❤️ by Suraj Kumar Sah</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;